/**
 * @generated SignedSource<<102fcdc660dbea1fedcf13a7ecfa8f1e>>
 * @relayHash 45ec6319306c3466a0324f267f19e655
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f651ef3a7aee47210e5ee1a4b482718d3c652d1681178a8a701b7c7535c46da

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7f651ef3a7aee47210e5ee1a4b482718d3c652d1681178a8a701b7c7535c46da",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
